<template>
  <li
    class="TheHeaderNavItem nav-item"
  >
    <router-link
      v-if="currentApp"
      :to="path"
      class="nav-item__link"
      :class="{ 'is--not-clickable': !clickable }"
      :aria-label="`Click on ${name} link`"
    >
      <span>{{ name }}</span>
      <!-- eslint-disable vue/no-v-html -->
      <span
        v-if="hasChildren"
        class="svg-icon nav-item__link-icon"
        alt="Carrot"
        v-html="require(`!!raw-loader!images/icons/new-chevron-down.svg`).default"
      />
    </router-link>
    <a
      v-else
      :href="path"
      class="nav-item__link"
      :class="{ 'is--not-clickable': !clickable }"
      :aria-label="`Click on ${name} link`"
    >
      <span>{{ name }}</span>
      <!-- eslint-disable vue/no-v-html -->
      <span
        v-if="hasChildren"
        class="svg-icon nav-item__link-icon"
        alt="Carrot"
        v-html="require(`!!raw-loader!images/icons/new-chevron-down.svg`).default"
      />
    </a>
    <ul
      v-if="hasChildren"
      class="dropdown-menu"
    >
      <template
        v-for="(subMenuItem, index) in children"
        :key="index"
      >
        <li
          v-if="subMenuItem.currentApp"
          class="dropdown-menu__item"
        >
          <router-link
            :to="subMenuItem.path"
            class="dropdown-menu__item-link"
            :aria-label="`Click on ${subMenuItem.name} link`"
          >
            <span>{{ subMenuItem.name }}</span>
          </router-link>
        </li>
        <li
          v-else-if="subMenuItem.path.startsWith('/')"
          class="dropdown-menu__item"
        >
          <a
            :href="subMenuItem.path"
            class="dropdown-menu__item-link"
            :aria-label="`Click on ${subMenuItem.name} link`"
          >
            <span>{{ subMenuItem.name }}</span>
          </a>
        </li>
        <li
          v-else
          class="dropdown-menu__item"
        >
          <a
            :href="subMenuItem.path"
            target="_blank"
            class="dropdown-menu__item-link"
            :aria-label="`Click on ${subMenuItem.name} link`"
          >{{ subMenuItem.name }}</a>
        </li>
      </template>
    </ul>
  </li>
</template>

<script lang="ts">
import {
  defineComponent,
  PropType,
} from 'vue';

export default defineComponent({
  name: 'TheHeaderNavItem',
  props: {
    name: {
      type: String as PropType<string>,
      required: true,
    },
    path: {
      type: String,
    },
    children: {
      default: () => ([]),
      type: Array,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    currentApp: Boolean,
  },
  setup(props) {
    const hasChildren = Boolean(props.children.length);

    return {
      hasChildren,
    };
  },
});
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.nav-item
  margin: 0 15px
  position: relative
  cursor: pointer
  display: flex
  align-items: center
  @media screen and (max-width: 1024px)
    margin: 0 10px
  &:last-child
    margin-right: 0
  &:first-child
    margin-left: 0
  &__link
    padding: 25px 0
    font-size: 14px
    display: flex
    align-items: center
    &.is--not-clickable
      pointer-events: none
  &__link-icon
    margin-left: 4px
    position: relative
    display: inline
    vertical-align: baseline
    :deep(svg)
      width: 16px
      height: 16px
      fill: $text_gray
  &:hover
    .dropdown-menu
      visibility: visible
      opacity: 1
      +mt(.1s)
    .dropdown-menu__item
      z-index: 1
      pointer-events: auto
.dropdown-menu
  position: absolute
  padding-top: 10px
  padding-bottom: 10px
  padding-left: 0
  cursor: pointer
  overflow: hidden
  visibility: hidden
  background-color: #fff
  opacity: 0
  +mt(.1s)
  +elevation(1)
  top: 64px
  width: 146px
  min-width: max-content
  left: 50%
  transform: translate(-50%, 0px)
  @media screen and (max-width: 767px)
    position: relative
    height: 0
    top: 0
  &__item
    background-color: #fff
    padding: 0
    width: 100%
    margin: 1px 0
    pointer-events: none
    display: flex
    &:hover
      transition: all 0.3s ease-in-out
      .dropdown-menu__item-link
        color: $text_gray
  &__item-link
    font-size: 14px
    line-height: 20px
    +font(500)
    color: $primary
    padding: 10px 20px
    width: 100%
    display: flex
</style>
